import * as  React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Api } from './@context/Api';
import stylesheet from './constants/stylesheet';
import { createStyles, makeStyles } from '@material-ui/styles';
import 'minireset.css';
import Menu from './Components/Menu';
import { ResponsiveProvider } from './@context/Responsive';
import mediaQueries from './constants/responsive';
import Page from './Components/Page';
import { ParallaxProvider } from 'react-scroll-parallax';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      'html, body': {
        position: 'relative',
        width: '100%',
        height: '100%',
        ...stylesheet.Body,
        // WebkitFontSmoothing: 'antialiased',
      },
      'a': {
        textDecoration: 'none',
        fontFamily: 'inherit',
        color: 'inherit'
      },
      'img':{
        width: '100%',
      },
      '#root': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'white'
      },
      '.custom-style-main-title':{
        ...stylesheet.MainTitle
      },
      '.custom-style-subtitle':{
        ...stylesheet.SubTitle
      },
      '.custom-style-blue-title':{
        ...stylesheet.BlueTitle
      },
      '.custom-style-quote':{
        ...stylesheet.Quote
      },
      '.news-style-main-title':{
        ...stylesheet.MainTitleNews
      },
      '.news-style-subtitle':{
        ...stylesheet.SubTitleNews
      },
      '.news-style-quote':{
        ...stylesheet.QuoteNews
      },
      'p strong':{
        ...stylesheet.MediumText
      }
    },
    app: {
      position: 'relative',
      fontSize: '1rem',
      zIndex: 0,
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    menuContainer: {
      position: 'sticky',
      top: 0,
      zIndex: 20,
      background: 'white',
      flex:'0 0 auto',
    },
    content: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      flex:'1 1 auto',
    },
  }));

const App: React.FC = () => {
  const cls = useStyles();

  return (
    <Router>
      <Api>
        <ResponsiveProvider mediaQueries={mediaQueries} >
          <div className={cls.app} id={"scrollContainer"}>
            <div className={cls.menuContainer}>
              <Menu />
            </div>
            <ParallaxProvider >
              <main className={cls.content}>
                <Switch>
                  {
                    // tslint:disable-next-line:jsx-no-lambda
                    <Route render={() => <Page />} />
                  }
                </Switch>
              </main>
            </ParallaxProvider>
          </div>
        </ResponsiveProvider>
      </Api>
    </Router>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx